import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { getSenderStatValueClass } from './senderUtils';
import { SmsSenderStatus } from './types';

type SenderStatItem = {
  key: string;
  labelKey: string;
  value: number;
  status: SmsSenderStatus;
};

type SmsSenderListStatsProps = {
  stats: SenderStatItem[];
};

export const SmsSenderListStats: FC<SmsSenderListStatsProps> = ({ stats }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-4'>
      {stats.map((item) => (
        <div key={item.key} className='rounded-2xl border border-secondary-border bg-white px-5 py-4 shadow-sm'>
          <p className={twMerge('text-3xl font-semibold tracking-tight', getSenderStatValueClass(item.status))}>{item.value}</p>
          <p className='text-secondary-600 mt-1 text-sm font-medium'>{t(item.labelKey)}</p>
        </div>
      ))}
    </div>
  );
};
